import { GroupOwnerAction } from "../../types/contexts/groupOwnerContext/groupOwnerAction.types";
import { Store } from "../../types/contexts/groupOwnerContext/store.types";
import actions from "./actions";

const reducer = (state: Store, action: GroupOwnerAction): Store => {
	switch (action.type) {
		case actions.SET_GROUP_OWNER: {
			return {
				...state,
				groupOwner: action.payload
			};
		}
		default:
			throw new Error("Unexpected action: Group Owner Context");
	}
};

export default reducer;
